/**
 * Immediate rug variant price fallback.
 * The theme's native variant-picker/product-rerender remains authoritative.
 * This only updates the main visible price and form variant ID immediately,
 * preventing a stale price if the async rerender is delayed or interrupted.
 */
(function () {
  if (window.__rugVariantPriceFallbackInitialized) return;
  window.__rugVariantPriceFallbackInitialized = true;

  function updateRugPrice(input) {
    if (!input || !input.matches('.rug-size-picker__input[data-rug-variant-id]')) return;

    var item = input.closest('.rug-size-picker__item');
    var picker = input.closest('.rug-size-picker');
    var buybox = input.closest('.rug-buybox');
    var priceTemplate = item && item.querySelector('template[data-rug-main-price-template]');
    var priceContainer = buybox && buybox.querySelector('.rug-price');
    var variantId = input.getAttribute('data-rug-variant-id');
    var formId = input.getAttribute('form') || (picker && picker.getAttribute('form-id'));
    var form = formId && document.getElementById(formId);
    var variantInput = form && form.querySelector('input[name="id"]');

    if (variantInput && variantId) {
      variantInput.disabled = false;
      variantInput.value = variantId;
    }

    if (priceTemplate && priceContainer) {
      priceContainer.replaceChildren(priceTemplate.content.cloneNode(true));
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.rug-size-picker__input[data-rug-variant-id]');
    if (input && input.checked) updateRugPrice(input);
  });
})();
